// extracted by css-extract-rspack-plugin
export default {"icon":"nNPay","apple":"SM_1N"};